export default "__VITE_PUBLIC_ASSET__e4a0b904__"